import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	retryMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewIssueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewIssueLabelIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorMessage: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.error-message',
		defaultMessage: "Couldn't retrieve data",
		description: 'The text for when an error occurs when loading options',
	},
	retryMessage: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.retry-message',
		defaultMessage: 'Click to retry',
		description: 'The text for button to reload options',
	},
	viewIssueLabel: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.view-issue-label',
		defaultMessage: 'View Issue',
		description: 'The dropdown item text that links to the selected issue',
	},
	viewIssueLabelIssueTerminologyRefreshM4: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.view-issue-label-issue-terminology-refresh-m4',
		defaultMessage: 'View work item',
		description: 'The dropdown item text that links to the selected issue',
	},
});
export default messages;
